<template>
  <div class="substep-smart-notifications">
    <AppDialog
      :show="showDialog"
      append-to-body
      class="getting-started-free-trial-insights-dialog"
      position="top"
      title=" "
      size="medium"
      @close="closeDialog"
    >
      <div slot="titleLabel">
        <h3>Free Insights Trial</h3>
        <h5>Congrats! You got a free 14 day trial of our most popular add-on: <b>Insights.</b></h5>
      </div>

      <div class="text-center">
        <img
          :src="images.free_trial_insights.src"
          :alt="images.free_trial_insights.alt"
        />
        <p class="mt-20 text-sm">
          You can cancel this at any time during the 14 days. After that you will be charged ${{
            insightsTrialMonthlyPrice
          }}/seat/month.
        </p>
      </div>

      <template slot="footer">
        <AppButton @click="closeDialog"> Close </AppButton>
      </template>
    </AppDialog>
    <div class="substep-header">
      <h3 data-testId="step-title">Create a smart notification</h3>
      <p>Get notified automatically when specific events happen within your organization.</p>
    </div>
    <div class="substep-body">
      <div class="notifications-cards">
        <div
          v-for="(card, index) in notificationTemplates"
          :key="card.key"
          class="notification-card"
        >
          <img
            :src="card.src"
            :alt="card.label"
            class="card-image"
          />

          <div class="card-wrapper">
            <h3 class="card-title">
              {{ card.label }}
            </h3>
            <div class="card-description">
              <p>{{ card.description }}</p>
            </div>
            <div class="card-triggers">
              <div class="trigger">
                <img
                  :title="`Frequency of notification`"
                  :src="assets.triggers.ICON_WATCH"
                  :alt="card.frequency"
                />
                <span>{{ card.frequency }}</span>
              </div>
              <div class="trigger">
                <img
                  :title="`Notification platform`"
                  :src="assets.triggers.ICON_BELL"
                  alt="Email"
                />
                <span>Email</span>
              </div>
            </div>
            <div class="card-footer">
              <AppButton
                v-if="!notificationExists(card.label)"
                :disabled="submitting[index]"
                type="outline"
                @click="createNotification(card, index)"
              >
                Create
              </AppButton>
              <AppButton
                v-else
                :disabled="submitting[index]"
                type="outline-success"
                @click="deleteNotification(card, index)"
              >
                Created
                <i class="hi hi-check hi-12"></i>
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import SmartNotificationWizardMixin from '~/mixins/GrowthWizard/SmartNotificationWizardMixin';

export default {
  name: 'CreateASmartNotification',
  mixins: [GettingStartedMixin, SmartNotificationWizardMixin],
  data() {
    return {
      notificationPresets: ['high_activity', 'overworking', 'underworking', 'low_activity'],
    };
  },
};
</script>
